import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React from 'react';
import { Link } from 'react-router-dom';
import { ICON_NAMES } from '../../../utils/Constants';
import * as globalStyles from '../../../utils/GlobalStyles';
import ConfirmationButtonView from '../../atoms/ConfirmationButtonView';

export default function SelectableButtonGroupView(props) {
  const {
    options = [], //an array of objects that each have an id, name
    selectedOptionId,
    onSelect, //an action that takes an id prop
    isRestricted = false,
    restrictedButtonParams = {},
    fixedTabWidth,
    restrictedType = 'premium',
    isSpaced = false,
    borderColor = globalStyles.colors.gray2,
    isScrollable = false,
    withBorder = true,
  } = props;

  const tabWidth = fixedTabWidth ? 114 : undefined;

  const dynamicTabStyle = {
    width: tabWidth,
    minWidth: tabWidth,
    padding: fixedTabWidth ? 0 : 16,
    color: globalStyles.colors.text1,
    marginRight: isSpaced ? 40 : undefined,
  };

  const normalButton = (option, idx) => (
    <Tab
      key={`optionButton${option.name}`}
      style={dynamicTabStyle}
      component={!!option.route ? Link : undefined}
      to={!!option.route ? option.route : undefined}
      label={option.name}
      onClick={onSelect ? () => onSelect(option.id) : undefined}
    />
  );

  const restrictedButton = (option, idx) => {
    switch (restrictedType) {
      case 'premium':
      default:
        return (
          <ConfirmationButtonView
            key={`optionButton${option.name}`}
            label={option.name}
            isTab
            {...restrictedButtonParams}
            confirmationTitle="You've found a Premium Feature!"
            leftTitleIconName={ICON_NAMES.STAR}
            confirmationMessage={'Subscribe in order to filter by source type.'}
            confirmationButtonText="Subscribe"
            color={selectedOptionId === option.id ? 'primary' : 'secondary'}
            style={dynamicTabStyle}
          />
        );
    }
  };

  const dynamicContainerStyle = {
    ...styles.container,
    borderBottom: withBorder ? `.4px solid ${borderColor}` : undefined,
    maxWidth: '100%',
    overflowX: 'hidden',
    boxSizing: 'border-box',
  };

  const selectedIdx = options.findIndex((option) => selectedOptionId === option.id);

  return (
    <div style={dynamicContainerStyle}>
      <Tabs
        value={selectedIdx == -1 ? false : selectedIdx}
        variant={isScrollable ? 'scrollable' : undefined}
        scrollButtons={isScrollable ? 'auto' : false}
        allowScrollButtonsMobile={isScrollable}>
        {options.map((option, idx) =>
          isRestricted && idx > 0 ? restrictedButton(option, idx) : normalButton(option, idx),
        )}
      </Tabs>
    </div>
  );
}

const styles = {
  container: {
    marginTop: '-12px',
    paddingLeft: 12,
    paddingRight: 12,
  },
};
